import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

import { LocalStorageKeys } from "../constants/localStorageKeys";

const FULL_DRAWER_WIDTH = 260;
const COLLAPSED_DRAWER_WIDTH = 72;

export const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem(LocalStorageKeys.SIDEBAR_COLLAPSED);
    return saved === "true";
  });

  useEffect(() => {
    localStorage.setItem(LocalStorageKeys.SIDEBAR_COLLAPSED, isCollapsed);
  }, [isCollapsed]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const currentDrawerWidth = isCollapsed
    ? COLLAPSED_DRAWER_WIDTH
    : FULL_DRAWER_WIDTH;

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Sidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />
      <TopBar
        handleDrawerToggle={handleDrawerToggle}
        drawerWidth={currentDrawerWidth}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          mt: 8,
          ml: { sm: 0 },
          width: { xs: "100%", sm: `calc(100% - ${currentDrawerWidth}px)` },
          transition: (theme) =>
            theme.transitions.create(["width", "margin"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};
